<div class=" mt-4 p-5 card">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <button class="btn btn-primary" (click)="goToPreviousMonth()">
      &larr;
    </button>

    <h4 class="m-0 text-center flex-grow-1">
      {{ title }}
    </h4>

    <button class="btn btn-primary" (click)="goToNextMonth()">
      &rarr;
    </button>
  </div>
  <table class="table table-striped table-bordered text-center">
    <thead class="table-dark">
    <tr>
      <th>Dom</th>
      <th>Seg</th>
      <th>Ter</th>
      <th>Qua</th>
      <th>Qui</th>
      <th>Sex</th>
      <th>Sáb</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let week of weeks">
      <td *ngFor="let dayObj of week" [class.today]="isToday(dayObj)" (click)="abrirNovoCompromisso(dayObj)" style="cursor: pointer;">
        <div *ngIf="dayObj">
          <strong>{{ dayObj.day }}</strong>
          <ul class="list-unstyled text-start small mt-1">
            <li *ngFor="let evento of getEventosFiltrados(dayObj.dataComparacao)" (click)="$event.stopPropagation()">
              <a (click)="buscarDetalheTarefa(evento.id)" [ngClass]="{'riscado-finalizado': evento.finalizada, 'atrasada': evento.atrasada && !evento.finalizada}">{{ evento.hora }} - {{ evento.descricao }}</a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<app-detalhes-tarefas
  [showModal] = "showModalDetalhes"
  (fecharModalPai)="fecharModalDetalhes()"
></app-detalhes-tarefas>
